<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search">
                <div class="search_item">
                    <div class="title"></div>
                    <div class="input_box">
                        <el-select v-model="searchForm.drug_code"
                                   class="width_300"
                                   size="nomal"
                                   @change="getTableData()"
                                   placeholder="请选择药物">
                            <el-option v-for="(item, index) in drugList"
                                       :label="item.name"
                                       :value="item.value"
                                       :key="index"></el-option>
                        </el-select>
                    </div>
                </div>
            </div>
            <div class="btn_box">
                <el-button size="small"
                           type="primary"
                           :loading="loadingDown"
                           @click="downExcel">导出</el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      ref="tableFixed"
                      stripe
                      width="100%"
                      height="100%">
                <el-table-column type="index" fixed="left" width="65" label="序号"></el-table-column>
                <el-table-column
                        v-for="(item, index) in columnData"
                        :prop="item.value"
                        :label="item.name"
                        :width="item.width"
                        :formatter="item.formatter"
                        :fixed="item.fixed"
                        show-overflow-tooltip
                        :key="index"></el-table-column>
            </el-table>
        </div>

        <div class="bottom_page">
            <page-view @getTableList="handleCurrentChange"
                       :currentPage="currentPage"
                       :pageSize="pageSize"
                       :total="total"></page-view>
        </div>
    </div>
</template>

<script>
    import {clone} from "@/global/utils";
    import {getUrl} from "@/api/index";
    import configs from "@/global/config"

    export default {
        name: "tableView",
        components: {},
        data() {
            return {
                currentPage: 1,
                pageSize: 50,
                total: 0,

                searchForm: {
                    drug_code: '1',
                },
                loadingDown: false,
                drugList: [
                    {name: '信迪利单抗（达伯舒）', value: '1'},
                    {name: '佩米替尼（达伯坦）', value: '2'},
                    {name: 'FGFR+', value: '3'},
                ],

                tableData: [],
                columnData: []
            }
        },
        mounted() {
            this.getTableData()
        },
        methods: {
            handleCurrentChange(val) {
                this.getTableData(val)
            },
            getTableData(v = 1) {
                let params = {
                    page: v,
                    page_size: this.pageSize,
                    drug_code: this.searchForm.drug_code,
                };
                // console.log(params, '69');
                this.httpGet('/user/rep_stat_fill_list', params).then(res => {
                    this.columnData = res.data.headers;
                    this.tableData = res.data.data_list;
                    this.total = res.data.total;
                    this.currentPage = v;
                    this.$nextTick(() => {

                        this.$refs.tableFixed.doLayout()
                    })
                });
            },

            downExcel() {
                this.loadingDown = true;
                let string_url = `/user/rep_stat_fill_list_export?drug_code=${this.searchForm.drug_code}`;
                let url = configs.BASE_URL + getUrl(string_url);
                let a = document.createElement('a');
                a.href = url;
                // a.setAttribute('download', fileName);
                a.style.display = 'none';
                document.body.appendChild(a);
                setTimeout(() => {
                    a.click();
                    document.body.removeChild(a);
                    this.loadingDown = false;
                },1)
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
        .table {
            height: 100%;
        }
    }
</style>